<template>
    <rkm-area
        v-if="cliente && cliente.ativoAppConectasusCidadao"
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-form-checkbox v-model="data.model.integracaoAplicativo.habilitaAgendamentoConectasusCidadao">
                Habilitar agendamento de exames laboratoriais no APP Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite disponibilizar vagas de agendamento de exames laboratoriais no App do Cidadão. Quando desativado, o agendamento não é exibido no App, mesmo que esteja configurado.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>

        <rkm-row v-if="data.model.integracaoAplicativo.habilitaAgendamentoConectasusCidadao">
            <rkm-col>
                <rkm-tabs>
                    <rkm-tab title="Exame">
                        <TabExame :exames="exames" />
                    </rkm-tab>

                    <rkm-tab title="Laboratório">
                        <TabLaboratorio :laboratorios="laboratorios" />
                    </rkm-tab>

                    <rkm-tab title="Unidade solicitante">
                        <TabUnidadeSolicitante :unidades="unidadesSolicitantes" />
                    </rkm-tab>
                </rkm-tabs>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-form-checkbox v-model="data.model.integracaoAplicativo.habilitaVisualizacaoLaudoConectasusCidadao">
                Habilitar visualização de laudos de exames no APP Cidadão
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.left="{
                        html: true,
                        content: 'Quando ativado, permite que o cidadão visualize laudos de exames com resultado emitido no App do Cidadão. Quando desativado, os laudos não são exibidos no App.'
                    }"
                />
            </rkm-form-checkbox>
        </rkm-row>
    </rkm-area>
</template>

<script>
import {mapGetters} from 'vuex'
import TabExame from './tabs/TabExame'
import TabLaboratorio from './tabs/TabLaboratorio'
import TabUnidadeSolicitante from './tabs/TabUnidadeSolicitante'

export default {
    components: { TabExame, TabLaboratorio, TabUnidadeSolicitante },

    props: {
        data: { required: true, type: Object },
    },

    computed: {
        ...mapGetters({cliente: 'getCliente'}),

        laboratorios() {
            return this.data.model.integracaoAplicativo.laboratorios || []
        },

        exames() {
            return this.data.model.integracaoAplicativo.exames || []
        },

        unidadesSolicitantes() {
            return this.data.model.integracaoAplicativo.unidadesSolicitantes || []
        },
    },

    data: () => ({}),
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
